import { IBloodDrawConfirmationContract } from '@nkr/models/index';
import { TableWrapperSmall } from '../styles';
import ConfirmBloodDrawCompletionRow from './confirm-blood-draw-completion-row';

interface IProps {
    list: IBloodDrawConfirmationContract[],
    onConfirm: (contract: IBloodDrawConfirmationContract) => void
}

const ConfirmBloodDrawCompletion = (props: IProps) => {
    return (
        <TableWrapperSmall className='table table-striped table-condensed table-bordered'>
            <thead>
                <tr>
                    <th>Swap</th>
                    <th>Donor Center</th>
                    <th>Donor Alias</th>
                    <th>Recipient Center</th>
                    <th>Recipient Alias</th>
                    <th>Target Surgery Date</th>
                    <th>Scheduled Blood Draw Date</th>
                    <th>Did the Blood Draw Occur?</th>
                </tr>
            </thead>
            <tbody>
                {props.list.map(item =>
                    <ConfirmBloodDrawCompletionRow
                        key={item.id}
                        item={item}
                        onConfirm={props.onConfirm}
                    />
                )}
            </tbody>
        </TableWrapperSmall>
    );
};

export default ConfirmBloodDrawCompletion;
